import axiosInstance from "./AxiosInstance"

export function getPayrollListApi(param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/payroll?${fparam}`)
}

export function getPayrollExportApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/payroll?${fparam}`, {
    responseType: "blob",
  });
}
export function bulkEmployeePaidSalary(data){
    return axiosInstance.patch('api/payroll/status/',data)
}
export function checkPayrollAvailbaleApi(param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/payroll-created-status?${fparam}`)
}
export function createPayrollApi(data){
    return axiosInstance.post('api/payroll',data)
}

export function updateEmployeeSalaryApi(data){
    return axiosInstance.patch('api/payroll/update-addon-deductions/',data)
}

export function getEmployeeSalaryDetailsApi(id,year){
    return axiosInstance.get(`api/payroll-report/${id}/?year=${year}`)
}

export function getEmployeeSalaryExportApi(id,param) {
    const fparam=new URLSearchParams(param).toString()
  return axiosInstance.get(`api/payroll-report/${id}/?${fparam}`, {
    responseType: "blob",
  });
}